export default "__VITE_ASSET__$J0mVOgD__"